export const SET_SELECTED_CATEGORY = "CATEGORY/SET_SELECTED_CATEGORY";
export const UNSET_SELECTED_CATEGORY = "CATEGORY/UNSET_SELECTED_CATEGORY";
export const SET_CATEGORIES_LIST = "CATEGORY/SET_CATEGORIES_LIST";
export const SET_CATEGORIES_FETCHING = "CATEGORY/SET_CATEGORIES_FETCHING";
export const UNSET_CATEGORIES_FETCHING = "CATEGORY/UNSET_CATEGORIES_FETCHING";
export const SET_CATEGORIES_LISTING_TABLE = "CATEGORY/SET_CATEGORIES_LISTING_TABLE";
export const SET_CATEGORIES_LISTING_GRID = "CATEGORY/SET_CATEGORIES_LISTING_GRID";
